<span class="font-main font-bold text-2xl pl-3 flex mb-3">{{ threadGroup.key }}</span>
@for (threadView of threadGroup.values; track $index) {
  <app-thread-group-comment-view [threadView]="threadView"></app-thread-group-comment-view>
}
<hr class="mt-3" />
